
import { Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Get, Optic_Get_op_HatDot_Z146BA564, Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Optic_Map_op_HatPercent_Z32F545AB, Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Optics_Option_value_, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z335E5A0C } from "../Common/Optics.js";
import { MemoryEditorData, Msg, sheet_, currentProj_ } from "../Model/ModelType.js";
import { NumberBase, Memory1, InitMemData, loadedComponents_, componentsState_, $007CMemoryAndType$007C_$007C, type_, $007CMemory$007C_$007C } from "../Common/CommonTypes.js";
import { empty as empty_1, singleton, ofArray, tryPick, collect, append, filter, choose, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { initialiseMem } from "../Interface/FilesIO.js";
import { List_distinctBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { add, tryFind, isEmpty, empty, map as map_1, toList } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { DrawModelType_SymbolT_component_, DrawModelType_SymbolT_symbols_, DrawModelType_BusWireT_symbol_, DrawModelType_SheetT_wire_ } from "../Model/DrawModelType.js";
import { equals as equals_1, createAtom, int32ToString, uncurry2, arrayHash, equalArrays } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { printf, toText, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { errorNotification, errorFilesNotification } from "./Notifications.js";
import { Prop, DOMAttr, HTMLAttr, CSSProp } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { min, op_Addition, op_Subtraction, fromInt32, fromOne, op_LeftShift, fromZero, compare, equals } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { strToIntCheckWidth, twosComp, strToBigint, fillHexBignum, fillBinBignum, hexBignum, sDecBignum, binBignum, decBignum } from "../Simulator/NumberHelpers.js";
import { right, left, Level_Option, level, Item_Option, item } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option, div } from "../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { div as div_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Control.fs.js";
import { Option as Option_1, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Common_GenericOption, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option as Option_2, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { getTextEventValue } from "../Interface/JSHelpers.js";
import * as react from "react";
import { input as input_1, checkbox } from "../fable_modules/Fulma.3.0.0/Elements/Form/Checkbox.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { memoryWidthsInDesign } from "./ModelHelpers.js";
import { value as value_5, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { TableOption, table as table_1 } from "../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { empty as empty_2, singleton as singleton_1, append as append_1, delay, toList as toList_1 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { locationProblemAtWidths } from "../Common/MemoryData.js";
import { DrawModelType_SheetT_Model__Model_WriteMemoryLine, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37 } from "../DrawBlock/Sheet.js";
import { warn } from "../Shared/Log.js";
import { toString } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { rangeBigInt } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { showMemoryEditorPopup } from "../DrawBlock/PopupHelpers.js";

export const project_ = Compose_Lens_op_GreaterMinusGreater_Z335E5A0C(Compose_Lens.Lens, Optics_Option_value_())(currentProj_);

export const memory1_ = [(a) => {
    const activePatternResult = $007CMemory$007C_$007C(a.Type);
    if (activePatternResult != null) {
        const mem = activePatternResult;
        return mem;
    }
    else {
        return undefined;
    }
}, (mem_1) => Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, type_)((typ) => {
    const activePatternResult_1 = $007CMemoryAndType$007C_$007C(typ);
    if (activePatternResult_1 != null) {
        const typ_1 = activePatternResult_1[0];
        return typ_1(mem_1);
    }
    else {
        return typ;
    }
})];

/**
 * Updates FromData memories from linked files in all LoadedComponents INCLUDING that of the open sheet
 * For the open sheet the update must also be made be on the draw blok component
 */
export function updateLoadedComponentMemory(memUpdate) {
    const compUpdate = Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, memory1_)(memUpdate);
    return Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, project_)((p) => {
        const ldcs = map(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, componentsState_)((list) => map(compUpdate, list)), p.LoadedComponents);
        return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, loadedComponents_)(ldcs)(p);
    });
}

/**
 * Update one FromData Memory1 in project to equal its linked file memory file contents.
 * A component whose file cannot be read keeps the contents it already has - see
 * firstMemoryFileError, which reports that, since on its own it is silent.
 */
export function updateMemory(p, mem) {
    if (mem.Init.tag === 1) {
        const _arg = initialiseMem(mem, p.ProjectPath);
        if (_arg.tag === 1) {
            return mem;
        }
        else {
            return _arg.fields[0];
        }
    }
    else {
        return mem;
    }
}

function linkedMemories(p, model) {
    let l_4, l_2;
    const memoriesOf = (comps) => choose((c) => {
        const activePatternResult = $007CMemory$007C_$007C(c.Type);
        if (activePatternResult != null) {
            const mem = activePatternResult;
            return mem;
        }
        else {
            return undefined;
        }
    }, comps);
    return List_distinctBy((mem_2) => [mem_2.Init, mem_2.AddressWidth, mem_2.WordWidth], filter((mem_1) => {
        if (mem_1.Init.tag === 1) {
            return true;
        }
        else {
            return false;
        }
    }, append(memoriesOf(map((tupledArg) => tupledArg[1].Component, toList(Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, (l_4 = ((l_2 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_symbol_)(l_2))), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_symbols_)(l_4)))(model)))), collect((ldc) => memoriesOf(ldc.CanvasState[0]), p.LoadedComponents))), {
        Equals: equalArrays,
        GetHashCode: (x) => (arrayHash(x) | 0),
    });
}

/**
 * Why the first unreadable linked .ram file cannot be read, if there is one.
 * updateMemory leaves such a memory holding its previous contents - all zeros in a project
 * that has just been opened - without saying so, so this must be reported wherever those
 * contents are about to be used.
 */
export function firstMemoryFileError(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        return tryPick((mem) => {
            const matchValue_1 = mem.Init;
            const matchValue_2 = initialiseMem(mem, p.ProjectPath);
            let matchResult, e, fName;
            if (matchValue_1.tag === 1) {
                const copyOfStruct = matchValue_2;
                if (copyOfStruct.tag === 1) {
                    matchResult = 0;
                    e = copyOfStruct.fields[0];
                    fName = matchValue_1.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return concat("Memory file \'", fName, ".ram\' could not be read, so memory components linked to it ") + concat("still hold their previous contents (all zeros in a newly opened project). ", e);
                default:
                    return undefined;
            }
        }, linkedMemories(p, model));
    }
    else {
        return undefined;
    }
}

/**
 * Report the first unreadable linked .ram file, if any. Called where memory contents are
 * about to be used, not from the periodic check, which would re-raise it twice a second.
 */
export function notifyMemoryFileErrors(dispatch, model) {
    const matchValue = firstMemoryFileError(model);
    if (matchValue == null) {
    }
    else {
        dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(matchValue)]));
    }
}

/**
 * Update all file-linked memory components in Draw Block (attached to symbols) and relevant loadedcomponent
 */
export function updateDrawBlockMemoryComps(memUpdate, p) {
    let l_6, l_4;
    const updateSymbol = Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z335E5A0C(Compose_Lens.Lens, memory1_)(DrawModelType_SymbolT_component_))((mem) => updateMemory(p, mem));
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, (l_6 = ((l_4 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_wire_)(sheet_), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_BusWireT_symbol_)(l_4))), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_symbols_)(l_6)))((table) => map_1(uncurry2((_arg) => updateSymbol), table));
}

/**
 * Update all file-linked memory components in Draw Block and LoadedComponents
 */
export function updateAllMemoryComps(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        return updateLoadedComponentMemory((mem_1) => updateMemory(p, mem_1))(updateDrawBlockMemoryComps((mem) => updateMemory(p, mem), p)(model));
    }
    else {
        return model;
    }
}

const popupExtraStyle = ofArray([new CSSProp(/* Width */ 395, ["65%"]), new CSSProp(/* Height */ 189, ["80%"])]);

const headerHeight = 60;

const headerStyle = ["style", {
    position: "fixed",
    marginTop: int32ToString(op_UnaryNegation_Int32(headerHeight) - 20) + "px",
    paddingTop: "20px",
    paddingBottom: "60px",
    backgroundColor: "white",
    width: "61%",
    height: headerHeight,
    zIndex: 32,
}];

const bodyStyle = ["style", {
    marginTop: int32ToString(headerHeight) + "px",
}];

function showError(msg, dispatch) {
    dispatch(new Msg(/* SetMemoryEditorNotification */ 81, [(dispatch_1) => errorNotification(msg, Msg.CloseMemoryEditorNotification, dispatch_1)]));
}

function closeError(dispatch) {
    dispatch(Msg.CloseMemoryEditorNotification);
}

function showRowWithAdrr(memoryEditorData, addr) {
    const matchValue = memoryEditorData.Address;
    if (matchValue != null) {
        if (equals(matchValue, addr)) {
            const a_1 = matchValue;
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
}

export function viewNum(numBase) {
    switch (numBase.tag) {
        case 1:
            return decBignum;
        case 2:
            return binBignum;
        case 3:
            return (num_3) => sDecBignum(0, num_3);
        default:
            return hexBignum;
    }
}

export function viewFilledNum(width, numBase) {
    switch (numBase.tag) {
        case 1:
            return decBignum;
        case 2:
            return fillBinBignum(width);
        case 3:
            return (num_1) => sDecBignum(width, num_1);
        default:
            return (n) => fillHexBignum(width, n);
    }
}

export let dynamicMem = createAtom(new Memory1(InitMemData.FromData, 0, 0, empty({
    Compare: (x, y) => (compare(x, y) | 0),
}), undefined));

export function baseSelector(numBase, changeBase_1) {
    return item(singleton(Item_Option.HasTextCentered), singleton(div(singleton(Option.HasAddonsCentered), ofArray([div_1(empty_1(), singleton(button(ofArray([new Option_1(/* Color */ 0, [equals_1(numBase, NumberBase.Hex) ? Color_IColor.IsPrimary : Color_IColor.NoColor]), new Option_1(/* OnClick */ 18, [(_arg) => {
        changeBase_1(NumberBase.Hex);
    }])]), singleton("hex")))), div_1(empty_1(), singleton(button(ofArray([new Option_1(/* Color */ 0, [equals_1(numBase, NumberBase.Dec) ? Color_IColor.IsPrimary : Color_IColor.NoColor]), new Option_1(/* OnClick */ 18, [(_arg_1) => {
        changeBase_1(NumberBase.Dec);
    }])]), singleton("dec")))), div_1(empty_1(), singleton(button(ofArray([new Option_1(/* Color */ 0, [equals_1(numBase, NumberBase.Bin) ? Color_IColor.IsPrimary : Color_IColor.NoColor]), new Option_1(/* OnClick */ 18, [(_arg_2) => {
        changeBase_1(NumberBase.Bin);
    }])]), singleton("bin"))))]))));
}

export function changeBase(memoryEditorData, dispatch, numBase) {
    return dispatch(new Msg(/* SetPopupMemoryEditorData */ 69, [new MemoryEditorData(memoryEditorData.OnlyDiff, memoryEditorData.Address, memoryEditorData.Start, numBase)]));
}

/**
 * Function creating react input box for memory address for use in WaveSim code (could also be used here).
 * setMemoryAddress dispatches a message to set the memory address to that typed in the input box.
 * numberBase, addressWidth configure the view.
 * TODO: make box width variable according to memory width?
 */
export function reactMemoryAddressInputBox(numberBase, addressWidth, setMemoryAddress, dispatch) {
    return input(ofArray([new Option_2(/* Type */ 1, [IInputType.Text$]), new Option_2(/* Props */ 15, [singleton(["style", {
        marginLeft: "10px",
        width: "80px",
    }])]), new Option_2(/* DefaultValue */ 10, [""]), new Option_2(/* Placeholder */ 12, [viewNum(numberBase)(fromZero())]), new Option_2(/* OnChange */ 13, [(arg) => {
        const text = getTextEventValue(arg);
        if (text === "") {
            closeError(dispatch);
            dispatch(setMemoryAddress(undefined));
        }
        else {
            const matchValue = strToBigint(text);
            if (matchValue.tag === 0) {
                const addr = matchValue.fields[0];
                if (compare(addr, op_LeftShift(fromOne(), addressWidth)) >= 0) {
                    showError("Address out of bounds.", dispatch);
                }
                else {
                    closeError(dispatch);
                    dispatch(setMemoryAddress(addr));
                }
            }
            else {
                showError(matchValue.fields[0], dispatch);
            }
        }
    }])]));
}

function makeEditorHeader(memory, isDiff, memoryEditorData, dispatch) {
    const children = [level(empty_1(), append(ofArray([item(singleton(Item_Option.HasTextCentered), ofArray([toText(`Number of elements: ${decBignum(op_LeftShift(fromOne(), memory.AddressWidth))}`), react.createElement("br", {}), toText(printf("Word width: %d bit(s)"))(memory.WordWidth)])), item(singleton(Item_Option.HasTextCentered), ofArray(["First Location To View or Change", input(ofArray([new Option_2(/* Type */ 1, [IInputType.Text$]), new Option_2(/* Props */ 15, [singleton(["style", {
        marginLeft: "10px",
        width: "80px",
    }])]), new Option_2(/* DefaultValue */ 10, [""]), new Option_2(/* Placeholder */ 12, [viewNum(memoryEditorData.NumberBase)(fromZero())]), new Option_2(/* OnChange */ 13, [(arg_1) => {
        const text = getTextEventValue(arg_1);
        if (text === "") {
            closeError(dispatch);
            dispatch(new Msg(/* SetPopupMemoryEditorData */ 69, [new MemoryEditorData(memoryEditorData.OnlyDiff, undefined, memoryEditorData.Start, memoryEditorData.NumberBase)]));
        }
        else {
            const matchValue = strToBigint(text);
            if (matchValue.tag === 0) {
                const addr = matchValue.fields[0];
                const w = memory.AddressWidth | 0;
                if ((w < 64) && (compare(addr, op_LeftShift(fromOne(), w)) >= 0)) {
                    showError("Address out of bounds.", dispatch);
                }
                else {
                    closeError(dispatch);
                    dispatch(new Msg(/* SetPopupMemoryEditorData */ 69, [new MemoryEditorData(memoryEditorData.OnlyDiff, addr, memoryEditorData.Start, memoryEditorData.NumberBase)]));
                }
            }
            else {
                showError(matchValue.fields[0], dispatch);
            }
        }
    }])]))])), baseSelector(memoryEditorData.NumberBase, (numBase) => {
        changeBase(memoryEditorData, dispatch, numBase);
    })]), isDiff ? singleton(item(singleton(Item_Option.HasTextCentered), singleton(checkbox(empty_1(), ofArray([input_1(singleton(new Common_GenericOption(/* Props */ 1, [ofArray([["style", {
        marginRight: "5px",
    }], new HTMLAttr(/* Checked */ 62, [memoryEditorData.OnlyDiff]), new DOMAttr(/* OnChange */ 9, [(_arg) => {
        dispatch(new Msg(/* SetPopupMemoryEditorData */ 69, [new MemoryEditorData(!memoryEditorData.OnlyDiff, memoryEditorData.Address, memoryEditorData.Start, memoryEditorData.NumberBase)]));
    }])])]))), "Show only if changed"]))))) : empty_1()))];
    return react.createElement("div", keyValueList([headerStyle, new HTMLAttr(/* SpellCheck */ 148, [false])], 1), ...children);
}

function makeEditorBody(memory, compId, memoryEditorData, model, dispatch) {
    let children_16, children_14, children_18, isReadOnly_1;
    const source = memory.Init;
    const isReadOnly = (source.tag === 5) ? "Fixed multiplier blocks cannot have initial value edited" : ((source.tag === 4) ? "Fixed multiplier blocks cannot have initial value edited" : ((source.tag === 1) ? concat("This memory takes initial values from ", source.fields[0], ".ram, edit the file to change them") : ((source.tag === 2) ? concat("This memory is linked to File ", source.fields[0], ".ram, changes made here will be save dto that file") : "")));
    const widths = memoryWidthsInDesign(model, compId, memory);
    const viewNumD = viewFilledNum(memory.WordWidth, memoryEditorData.NumberBase);
    const viewNumA = viewFilledNum(memory.AddressWidth, memoryEditorData.NumberBase);
    const numLocsToDisplay = fromInt32(16);
    const maxLocAddr = op_Subtraction(op_LeftShift(fromOne(), memory.AddressWidth), fromOne());
    let patternInput;
    const matchValue = memoryEditorData.Address;
    if (matchValue != null) {
        const a = matchValue;
        const maxDispLocWrapped = op_Subtraction(op_Addition(a, numLocsToDisplay), fromOne());
        patternInput = [a, min((compare(maxDispLocWrapped, a) > 0) ? maxDispLocWrapped : twosComp(memory.AddressWidth, fromInt32(-1)), maxLocAddr)];
    }
    else {
        patternInput = [fromZero(), min(maxLocAddr, numLocsToDisplay)];
    }
    const comments = defaultArg(memory.Comments, empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const hasComments = !isEmpty(comments);
    const children_20 = [isReadOnly, react.createElement("br", {}), table_1(singleton(TableOption.IsFullWidth), ofArray([(children_16 = [(children_14 = toList_1(delay(() => append_1(singleton_1(react.createElement("th", {}, "Address")), delay(() => append_1(singleton_1(react.createElement("th", {}, "Content")), delay(() => (hasComments ? singleton_1(react.createElement("th", {}, "Comment")) : empty_2()))))))), react.createElement("tr", {}, ...children_14))], react.createElement("thead", {}, ...children_16)), (children_18 = map((isReadOnly_1 = (isReadOnly !== ""), (addr_1) => {
        const content = defaultArg(tryFind(addr_1, memory.Data), fromZero());
        const props_6 = [new HTMLAttr(/* SpellCheck */ 148, [false]), ["style", {
            display: "table-row",
        }]];
        const children_6 = toList_1(delay(() => {
            let children;
            return append_1(singleton_1((children = [viewNumA(addr_1)], react.createElement("td", {}, ...children))), delay(() => {
                let children_2;
                return append_1(singleton_1((children_2 = toList_1(delay(() => singleton_1(input(ofArray([new Option_2(/* Type */ 1, [IInputType.Text$]), new Option_2(/* Props */ 15, [ofArray([new DOMAttr(/* OnBlur */ 8, [(ev) => {
                    let Data;
                    const matchValue_1 = strToIntCheckWidth(memory.WordWidth, getTextEventValue(ev));
                    if (matchValue_1.tag === 1) {
                        showError(matchValue_1.fields[0], dispatch);
                    }
                    else if (locationProblemAtWidths(widths, addr_1, matchValue_1.fields[0]) != null) {
                        showError(value_5(locationProblemAtWidths(widths, addr_1, matchValue_1.fields[0])), dispatch);
                    }
                    else {
                        const value_3 = matchValue_1.fields[0];
                        closeError(dispatch);
                        const _arg = DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(model.Sheet, compId).Type;
                        let matchResult_1, d;
                        switch (_arg.tag) {
                            case 41: {
                                matchResult_1 = 0;
                                d = _arg.fields[0];
                                break;
                            }
                            case 40: {
                                matchResult_1 = 0;
                                d = _arg.fields[0];
                                break;
                            }
                            case 39: {
                                matchResult_1 = 0;
                                d = _arg.fields[0];
                                break;
                            }
                            case 42: {
                                matchResult_1 = 0;
                                d = _arg.fields[0];
                                break;
                            }
                            default:
                                matchResult_1 = 1;
                        }
                        switch (matchResult_1) {
                            case 0: {
                                break;
                            }
                            case 1: {
                                warn(`a memory editor is open on ${compId}, which is not a memory`);
                                break;
                            }
                        }
                        dynamicMem((Data = add(addr_1, value_3, dynamicMem().Data), new Memory1(dynamicMem().Init, dynamicMem().AddressWidth, dynamicMem().WordWidth, Data, dynamicMem().Comments)));
                        DrawModelType_SheetT_Model__Model_WriteMemoryLine(model.Sheet, (sMsg) => {
                            dispatch(new Msg(/* Sheet */ 3, [sMsg]));
                        }, compId, addr_1, value_3);
                        dispatch(new Msg(/* ReloadSelectedComponent */ 87, [model.LastUsedDialogWidth]));
                    }
                }]), new Prop(/* Key */ 0, [toString(memoryEditorData.NumberBase) + toString([addr_1, content])])])]), new Option_2(/* Disabled */ 4, [isReadOnly_1]), new Option_2(/* DefaultValue */ 10, [viewNumD(content)]), new Option_2(/* OnChange */ 13, [(arg) => {
                    const matchValue_2 = strToIntCheckWidth(memory.WordWidth, getTextEventValue(arg));
                    if (matchValue_2.tag === 0) {
                        closeError(dispatch);
                    }
                    else {
                        showError(matchValue_2.fields[0], dispatch);
                    }
                }])]))))), react.createElement("td", {}, ...children_2))), delay(() => {
                    let props_4, children_4;
                    return hasComments ? singleton_1((props_4 = [["style", {
                        color: "grey",
                    }]], (children_4 = [defaultArg(tryFind(addr_1, comments), "")], react.createElement("td", keyValueList(props_4, 1), ...children_4)))) : empty_2();
                }));
            }));
        }));
        return react.createElement("tr", keyValueList(props_6, 1), ...children_6);
    }), toList_1(rangeBigInt(patternInput[0], 1n, patternInput[1]))), react.createElement("tbody", {}, ...children_18))]))];
    return react.createElement("div", keyValueList([bodyStyle], 1), ...children_20);
}

function makeFoot(editMode, dispatch, model) {
    return level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
        width: "100%",
    }])])), ofArray([left(empty_1(), empty_1()), right(empty_1(), singleton(item(empty_1(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsPrimary]), new Option_1(/* OnClick */ 18, [(_arg) => {
        dispatch(Msg.CloseMemoryEditorNotification);
        dispatch(Msg.ClosePopup);
        let matchResult;
        if (editMode != null) {
            if (editMode.tag === 0) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                dispatch(new Msg(/* ReloadSelectedComponent */ 87, [model.LastUsedDialogWidth]));
                break;
            }
            case 1: {
                break;
            }
        }
    }])]), singleton("Done"))))))]));
}

function makeEditor(memory, compId, model, dispatch) {
    let matchValue, mem;
    dynamicMem((matchValue = model.SelectedComponent, (matchValue != null) ? ((matchValue.Type.tag === 41) ? ((mem = matchValue.Type.fields[0], mem)) : ((matchValue.Type.tag === 40) ? ((mem = matchValue.Type.fields[0], mem)) : ((matchValue.Type.tag === 39) ? ((mem = matchValue.Type.fields[0], mem)) : ((matchValue.Type.tag === 42) ? ((mem = matchValue.Type.fields[0], mem)) : memory)))) : memory));
    return (memoryEditorData) => {
        const children = [makeEditorHeader(dynamicMem(), false, memoryEditorData, dispatch), makeEditorBody(dynamicMem(), compId, memoryEditorData, model, dispatch)];
        return react.createElement("div", {}, ...children);
    };
}

/**
 * Open a popup to view and edit the content of a memory.
 */
export function openMemoryEditor(memory, compId, model, dispatch) {
    const model_1 = updateAllMemoryComps(model);
    notifyMemoryFileErrors(dispatch, model_1);
    showMemoryEditorPopup("Memory editor", makeEditor(memory, compId, model_1, dispatch), makeFoot(memory.Init, dispatch, model_1), popupExtraStyle, dispatch);
}

function makeDiffViewerBody(memory1, memory2, memoryEditorData) {
    let children_20, children_18, children_22;
    const getData = (addr, memData) => defaultArg(tryFind(addr, memData), fromZero());
    const viewNum_1 = viewNum(memoryEditorData.NumberBase);
    const comments = defaultArg(memory1.Comments, empty({
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const hasComments = !isEmpty(comments);
    const addr_3 = defaultArg(memoryEditorData.Address, fromZero());
    const addr2 = op_Addition(addr_3, fromInt32(15));
    const children_24 = [table_1(singleton(TableOption.IsFullWidth), ofArray([(children_20 = [(children_18 = toList_1(delay(() => append_1(singleton_1(react.createElement("th", {}, "Address")), delay(() => append_1(singleton_1(react.createElement("th", {}, "Initial content")), delay(() => append_1(singleton_1(react.createElement("th", {}, "Current content")), delay(() => (hasComments ? singleton_1(react.createElement("th", {}, "Comment")) : empty_2()))))))))), react.createElement("tr", {}, ...children_18))], react.createElement("thead", {}, ...children_20)), (children_22 = map((a) => {
        const content1 = getData(a, memory1.Data);
        const content2 = getData(a, memory2.Data);
        const addr_1 = a;
        const hasChanged = !equals(content1, content2);
        const props_8 = [["style", {
            display: (showRowWithAdrr(memoryEditorData, addr_1) && (!memoryEditorData.OnlyDiff ? true : (memoryEditorData.OnlyDiff && hasChanged))) ? "table-row" : "none",
        }]];
        const children_8 = toList_1(delay(() => {
            let children;
            return append_1(singleton_1((children = [viewNum_1(addr_1)], react.createElement("td", {}, ...children))), delay(() => {
                let props_2, children_2;
                return append_1(singleton_1((props_2 = [["style", {
                    backgroundColor: hasChanged ? "#ffc6d3" : "auto",
                }]], (children_2 = [viewNum_1(content1)], react.createElement("td", keyValueList(props_2, 1), ...children_2)))), delay(() => {
                    let props_4, children_4;
                    return append_1(singleton_1((props_4 = [["style", {
                        backgroundColor: hasChanged ? "#baffd3" : "auto",
                    }]], (children_4 = [viewNum_1(content2)], react.createElement("td", keyValueList(props_4, 1), ...children_4)))), delay(() => {
                        let props_6, children_6;
                        return hasComments ? singleton_1((props_6 = [["style", {
                            color: "grey",
                        }]], (children_6 = [defaultArg(tryFind(addr_1, comments), "")], react.createElement("td", keyValueList(props_6, 1), ...children_6)))) : empty_2();
                    }));
                }));
            }));
        }));
        return react.createElement("tr", keyValueList(props_8, 1), ...children_8);
    }, toList_1(rangeBigInt(addr_3, 1n, addr2))), react.createElement("tbody", {}, ...children_22))]))];
    return react.createElement("div", keyValueList([bodyStyle], 1), ...children_24);
}

function makeDiffViewer(memory1, memory2, dispatch, memoryEditorData) {
    const children = [makeEditorHeader(memory1, true, memoryEditorData, dispatch), makeDiffViewerBody(memory1, memory2, memoryEditorData)];
    return react.createElement("div", {}, ...children);
}

export function openMemoryDiffViewer(memory1, memory2, model, dispatch) {
    showMemoryEditorPopup("Memory diff viewer", (memoryEditorData) => makeDiffViewer(memory1, memory2, dispatch, memoryEditorData), makeFoot(undefined, dispatch, model), popupExtraStyle, dispatch);
}

